export default __webpack_public_path__ + "static/media/2100.66701742.png";